export default __webpack_public_path__ + "static/media/imgLoja01.21115d84.png";